import PropTypes from "prop-types";

const Divider = ({ variant = "solid", className = "" }) => {
  const style = {
    solid: { borderTop: "1px solid #F2F4F7" },
    dashed: { borderTop: "1px dashed #E0E0E0" },
  };

  return <div className={`my-3 ${className}`} style={style[variant]} />;
};

Divider.propTypes = {
  variant: PropTypes.oneOf(["solid", "dashed"]),
  className: PropTypes.string,
};

export default Divider;
